'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var constants = require('./constants.js');

var generateGoalSeries = function (theme, dataPoints, goalName, goalValue, method, goalColorOverride) {
    if (!goalValue) {
        return {};
    }
    var data = [goalValue];
    while (data.length < dataPoints) {
        if (method) {
            data = tslib.__spreadArrays(data, [method(data[data.length - 1])]);
        }
        else {
            data = tslib.__spreadArrays(data, [data[data.length - 1]]);
        }
    }
    var lineColor = goalColorOverride || theme.palette.success.dark || '#31CC97';
    var color = goalColorOverride || theme.palette.success.dark || '#31CC97';
    return tslib.__assign(tslib.__assign({}, constants.goalSeries), { data: data, lineColor: lineColor, color: color, name: goalName });
};
var generateDataSeries = function (data, name, colorOverride) {
    var color = colorOverride || '#0184ff';
    return { name: name, data: data, color: color, lineWidth: 2 };
};
var generateXAxis = function (categories, autoRotationOverride, colorOverride, hasGridLine, rotationOverride) {
    if (rotationOverride === void 0) { rotationOverride = -45; }
    var max = categories.length - 1;
    var color = colorOverride || '#6E84A3';
    return tslib.__assign(tslib.__assign({}, constants.xAxisDefaults), { gridLineWidth: hasGridLine ? 1 : null, max: max,
        categories: categories, labels: {
            style: {
                color: color,
                font: 'normal 500 13px "TT Commons", Arial, sans-serif',
            },
            align: 'center',
            autoRotation: autoRotationOverride || false,
            rotation: rotationOverride,
            y: 30,
            x: 5,
        } });
};
var getPlotOptions = function (t, o) {
    var plotOptions = {
        series: {
            fillColor: {
                linearGradient: [0, -600, 0, 275],
                stops: [
                    [0, '#7cb5ec'],
                    [1, 'rgba(124, 181, 236, 0)'],
                ],
            },
            marker: {
                enabled: true,
            },
            states: {
                hover: {
                    lineWidthPlus: 0,
                },
            },
        },
        area: {
            threshold: 0,
            marker: {
                enabled: false,
                symbol: 'circle',
                radius: 5,
                states: {
                    hover: {
                        enabled: true,
                        fillColor: 'white',
                        lineColor: '#0184FF',
                        lineWidth: 4,
                        radius: 4,
                        lineWidthPlus: 0,
                        radiusPlus: 0,
                    },
                },
            },
        },
    };
    if (t) {
        plotOptions.area.threshold = t;
    }
    if (o) {
        plotOptions.series.fillColor.linearGradient = o;
    }
    return plotOptions;
};
var generateOptions = function (options) {
    var hasLegend = options.hasLegend, height = options.height, threshold = options.threshold, gradientOverride = options.gradientOverride, series = options.series, tooltipFormatter = options.tooltipFormatter, xAxisData = options.xAxisData, autoRotationOverride = options.autoRotationOverride, colorOverride = options.colorOverride, hasGridLine = options.hasGridLine, xAxisLabelRotation = options.xAxisLabelRotation, yAxisTitle = options.yAxisTitle, yAxisLabels = options.yAxisLabels, yAxisAddon = options.yAxisAddon, tickPositions = options.tickPositions;
    var formatter = function formatter() {
        // eslint-disable-next-line react/no-this-in-sfc
        return "" + this.value + (yAxisAddon || '');
    };
    var result = {
        legend: hasLegend ? constants.legend : '',
        credits: constants.credits,
        title: constants.title,
        chart: tslib.__assign(tslib.__assign({}, constants.chartType), { height: height }),
        plotOptions: getPlotOptions(threshold, gradientOverride),
        series: series,
        tooltip: {
            useHTML: true,
            borderRadius: 6,
            borderWidth: 1,
            borderColor: '#D6DCE5',
            backgroundColor: '#FFFFFF',
            style: {
                color: '#6E84A3',
            },
            formatter: tooltipFormatter,
        },
        xAxis: generateXAxis(xAxisData, autoRotationOverride, colorOverride, hasGridLine, xAxisLabelRotation),
        yAxis: tslib.__assign(tslib.__assign({}, constants.yAxis), { title: {
                text: yAxisTitle,
            }, gridLineWidth: yAxisLabels ? 1 : null, tickPositioner: constants.yAxis.tickPositioner, labels: {
                enabled: yAxisLabels,
                formatter: formatter,
                style: {
                    font: 'normal 500 13px "TT Commons", Arial, sans-serif',
                },
            } }),
    };
    if (tickPositions) {
        result.yAxis = tslib.__assign(tslib.__assign({}, result.yAxis), { 
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            tickPositioner: function () {
                return tickPositions;
            } });
    }
    return result;
};

exports.generateDataSeries = generateDataSeries;
exports.generateGoalSeries = generateGoalSeries;
exports.generateOptions = generateOptions;
exports.generateXAxis = generateXAxis;
